import * as React from "react";
import { CircleCheckBig, TriangleAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BusinessReportOutcomeDetails } from "@/modules/snapshots/businessReports.types";
import { useUpdateBusinessReportOutcomeMutation } from "@/modules/snapshots/businessReports.api";
import TopBarProgress from "react-topbar-progress-indicator";
import { useSnapshotPermission } from "@/modules/snapshots/hooks/useSnapshotPermission";

interface Props {
  businessReportOutcome: BusinessReportOutcomeDetails;
}

export const BusinessReportOutcomeVerify: React.FC<Props> = ({ businessReportOutcome }) => {
  const [updateBusinessReportOutcome, { isLoading }] = useUpdateBusinessReportOutcomeMutation();
  const handleClick = () => {
    updateBusinessReportOutcome({ id: businessReportOutcome.id, data: { verified: !businessReportOutcome.verified } });
  };

  const isReadOnly = !useSnapshotPermission(businessReportOutcome);

  return (
    <>
      {isLoading && <TopBarProgress />}
      {!businessReportOutcome.verified ? (
        <Button
          variant="default"
          size="sm"
          disabled={isLoading || isReadOnly}
          className="ml-1 rounded bg-primary px-4 py-2 text-white"
          onClick={handleClick}
        >
          <TriangleAlert className="mr-2 h-5 w-5" />
          Verify
        </Button>
      ) : (
        <Button
          variant="default"
          size="sm"
          disabled={isLoading || isReadOnly}
          className="ml-1 rounded bg-primary px-4 py-2 text-white"
          onClick={handleClick}
        >
          <CircleCheckBig className="mr-2 h-5 w-5" />
          Verified
        </Button>
      )}
    </>
  );
};
